import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { channelConfig } from '../../configs/signalr'
import { Realtime } from '../common/Realtime'
import Filter from './common/Filter'
import { SCREEN_TYPE, mapFilterActiveKey } from './constants'
import './i18n'
import {
  selectIds,
  selectLoadingByKey,
  selectPage,
  selectPageSize,
  selectTab,
} from './store/slice'
import { getPaged } from './store/thunk'
import Header from './viewAll/Header'
import Layout from './viewAll/Layout'
import NotificationList from './viewAll/NotificationList'

export const SystemNotifications = () => {
  const dispatch = useDispatch()
  const [isReCallApi, setIsReCallApi] = useState(false)

  const page = useSelector(selectPage(SCREEN_TYPE.VIEW_ALL))
  const locale = useSelector((state) => state.i18n.locale)
  const isLoading = useSelector(
    selectLoadingByKey('notifications', SCREEN_TYPE.VIEW_ALL),
  )
  const tab = useSelector(selectTab)
  const { todayIds, olderIds } = useSelector(selectIds(SCREEN_TYPE.VIEW_ALL))
  const pageSize = useSelector(selectPageSize)

  const action = () => {
    setIsReCallApi(!isReCallApi)
  }

  const params = {
    Page: page,
    PageSize: pageSize,
    IsRead: tab === mapFilterActiveKey.ALL ? undefined : false,
    screenType: SCREEN_TYPE.VIEW_ALL,
  }

  useEffect(() => {
    dispatch(getPaged(params))
  }, [locale, page, tab, pageSize, isReCallApi])

  return (
    <Realtime channel={channelConfig.UserNotification} action={action}>
      <Layout>
        <Header />
        <Filter screenType={SCREEN_TYPE.VIEW_ALL} params={params} />
        <NotificationList
          isLoading={isLoading}
          isAll={tab === mapFilterActiveKey.ALL}
          todayData={todayIds}
          olderData={olderIds}
        />
      </Layout>
    </Realtime>
  )
}

export default SystemNotifications
